import { OneRepMaxFormula } from ".";


export class Epley implements OneRepMaxFormula {
    name = "Epley";

    calculate(weight: number, reps: number) {
        return reps == 1 ? weight : weight * (1 + (reps / 30));
    }
}